import { Link } from 'react-router-dom';
import Spinner from '../skeletons/spinnerButton';
import clsx from 'clsx';

export default function ProductList({
  productsData,
  isLoading,
  gridCols = 'grid-cols-2 md:grid-cols-4 lg:grid-cols-6',
}) {
  // Hàm định dạng số lượng đã bán
  const formatSold = (sold) => {
    if (sold >= 1_000_000)
      return `${(sold / 1_000_000).toFixed(sold % 1_000_000 === 0 ? 0 : 1)}tr`;
    if (sold >= 1_000)
      return `${(sold / 1_000).toFixed(sold % 1_000 === 0 ? 0 : 1)}k`;
    return sold.toString();
  };

  return isLoading ? (
    <div
      className={clsx(
        'top-0 left-0 w-full h-[100px] flex items-center justify-center bg-red',
        isLoading ? 'bg-backgroundGrayColor' : 'hidden'
      )}
    >
      <Spinner
        size={'30px'}
        stroke={'6px'}
        _hidden={!isLoading ? 'hidden' : ''}
        color={'#ee4d2d'}
      />
    </div>
  ) : (
    <div className={clsx('grid gap-2 p-2 w-full', gridCols)}>
      {productsData &&
        productsData.map((product, index) => (
          <div
            key={product.id}
            className={clsx(
              'group flex flex-col h-[300px] relative',
              'hover:translate-y-[-1px] transition-transform duration-300 ease-out',
              'hover:shadow-[0_0_4px_rgba(0,0,0,0.2)] z-10 hover:z-[20]'
            )}
          >
            <Link
              to={`/product/${product.id}`}
              className={clsx(
                'flex flex-col h-full w-full bg-white',
                'border border-[#DFDFDF] hover:border-primaryTextColor pb-2'
              )}
            >
              <div
                className="w-full h-[190px] bg-gray-200 bg-cover bg-no-repeat bg-center"
                style={{
                  backgroundImage: `url(${product.image.imageUrl})`,
                }}
              ></div>
              <div className="w-full flex flex-col justify-between px-2 flex-1">
                <p
                  className={clsx(
                    'text-[14px] leading-[18px] text-start mt-[10px] overflow-hidden',
                    'h-[36px] line-clamp-2'
                  )}
                >
                  {product.favorite && (
                    <span
                      className={clsx(
                        'inline-block text-white text-[11px] bg-primaryTextColor',
                        'leading-[14px] px-1 rounded-[3px] mr-1 relative top-[-2px]'
                      )}
                    >
                      Yêu thích
                    </span>
                  )}
                  {product.name}
                </p>
                <div className="flex flex-row justify-between items-center">
                  <div
                    className="text-primaryTextColor flex items-end gap-[2px] justify-start 
                                    font-semibold"
                  >
                    <i className="fa-solid fa-dong-sign text-[12px] relative top-[-4px]"></i>
                    {/* Hiển thị Giá tiền nhỏ nhất then VND */}
                    {Math.min(
                      ...product.attributes.map((item) => item.price)
                    ).toLocaleString('vi-VN')}
                  </div>
                  <div className="w-full text-end text-[12px]">
                    Đã bán {formatSold(product.soldCount)}
                  </div>
                </div>
              </div>
            </Link>
            <div
              className={clsx(
                'h-[35px] text-[15px] text-white bg-primaryTextColor border border-primaryTextColor',
                'rounded-b-[3px] absolute top-[100%] left-0 right-0 z-10 opacity-0',
                'transition-all duration-100 ease-in-out group-hover:opacity-100 group-hover:translate-y-0'
              )}
            >
              <Link
                to={`/product/search/${product.name}`}
                className="w-full h-full flex items-center justify-center"
              >
                Tìm sản phẩm tương tự
              </Link>
            </div>
          </div>
        ))}
    </div>
  );
}
